export default "__VITE_ASSET__DuWaxOJH__"